import type { IAutoCompleteSiteItem } from "app/@types/autocomplete";
import type { Competitor } from "app/pages/sales-intelligence/modules/ai-agent/types/meeting";

export const mapCompetitorsToAutocompleteOptions = (competitors: Competitor[]): IAutoCompleteSiteItem[] => {
    return competitors.map((competitor) => ({
        name: competitor.domain,
        image: competitor.favicon,
        companyInfo: {
            companyName: competitor.companyName,
            mainDomain: competitor.domain,
            image: competitor.favicon,
        },
    })) as IAutoCompleteSiteItem[];
};

export const mapAutocompleteOptionsToCompetitors = (autocompleteItem: IAutoCompleteSiteItem): Competitor => ({
    domain: autocompleteItem.companyInfo?.mainDomain ?? "",
    favicon: autocompleteItem.image ?? "",
    companyName: autocompleteItem.companyInfo?.companyName ?? "",
});
